import { useParams, Link } from "react-router-dom";

const content = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "We respect your privacy. We collect only the information needed to process your purchase and deliver your digital guides — namely your email address and payment confirmation handled securely by Stripe.",
      "We never sell your data. We use your email to deliver purchases, send your download links and, if you opt in, occasional product updates.",
      "You can request deletion of your data at any time by contacting us.",
    ],
  },
  terms: {
    title: "Terms of Service",
    body: [
      "By purchasing from UpgradeMate you agree to use our digital guides for personal use only. Guides may not be resold, redistributed or shared.",
      "All purchases grant a single-user, lifetime license to the purchased content, including future updates.",
      "We reserve the right to update guide content to keep information current and accurate.",
    ],
  },
  refund: {
    title: "Refund Policy",
    body: [
      "Because our products are instantly delivered digital downloads, all sales are generally final.",
      "That said, we stand behind our work. If you're genuinely unsatisfied, contact us within 14 days of purchase and we'll make it right.",
      "Refund requests are reviewed individually — reach out via our contact page and we'll respond quickly.",
    ],
  },
};

export default function Legal() {
  const { type } = useParams();
  const c = content[type] || content.privacy;
  return (
    <div className="mx-auto max-w-3xl px-5 pt-16 pb-24 lg:pt-24 lg:pb-32" data-testid="legal-page">
      <Link to="/" className="text-sm text-muted-foreground hover:underline">← Home</Link>
      <h1 className="mt-6 font-display text-5xl font-extrabold tracking-tighter">{c.title}</h1>
      <div className="mt-8 space-y-6">
        {c.body.map((p, i) => <p key={i} className="text-base leading-relaxed text-muted-foreground">{p}</p>)}
      </div>
    </div>
  );
}
